var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.33335V6.66669C5 3.90835 5.83333 1.66669 10 1.66669C14.1667 1.66669 15 3.90835 15 6.66669V8.33335",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 15.4167C11.1499 15.4167 12.0827 14.484 12.0827 13.3334C12.0827 12.1828 11.1499 11.25 9.99935 11.25C8.84876 11.25 7.91602 12.1828 7.91602 13.3334C7.91602 14.484 8.84876 15.4167 9.99935 15.4167Z",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 18.3334H5.83268C2.49935 18.3334 1.66602 17.5 1.66602 14.1667V12.5C1.66602 9.16671 2.49935 8.33337 5.83268 8.33337H14.166C17.4993 8.33337 18.3327 9.16671 18.3327 12.5V14.1667C18.3327 17.5 17.4993 18.3334 14.166 18.3334Z",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.408fc51521127c802b8704041a5ca3b8.svg";
export { ForwardRef as ReactComponent };